module.exports = __webpack_public_path__ + "img/Minus.413a2ace.svg";